export default __webpack_public_path__ + "static/media/zm.ca392342.svg";